module.exports = __webpack_public_path__ + "img/load-4-1.74d30f83.png";